import { AxiosResponseHeaders, RawAxiosResponseHeaders } from "axios";

export const AUTH_TOKEN_KEY = "token";

export function extractAuthTokenFromHeaders(
  headers: RawAxiosResponseHeaders | AxiosResponseHeaders
): string | null {
  const headerRecord = headers as Record<string, string | undefined>;
  const token =
    headerRecord.authorization ||
    headerRecord.Authorization ||
    headerRecord["x-auth-token"] ||
    headerRecord["X-Auth-Token"];

  return token ?? null;
}

export function setAuthToken(token: string | null): void {
  if (token) {
    localStorage.setItem(AUTH_TOKEN_KEY, token);
  } else {
    localStorage.removeItem(AUTH_TOKEN_KEY);
  }
}

export function getAuthToken(): string | null {
  return localStorage.getItem(AUTH_TOKEN_KEY);
}
